import * as React from 'react';
import Svg, { Defs, LinearGradient, Rect, Stop } from 'react-native-svg';

const SVGComponent = props => (
    <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? '393'}
        height={props.height ?? '283'}
        viewBox={`0 0 393 283`}
        fill={'none'}
    >
        <Rect width="540" height="405" fill="url(#paint0_linear_59964_37678)" style="mix-blend-mode:overlay" />
        <Defs>
            <LinearGradient
                id="paint0_linear_59964_37678"
                x1="196"
                y1="0"
                x2="196"
                y2="405"
                gradientUnits="userSpaceOnUse"
            >
                <Stop stopOpacity="0" />
                <Stop offset="1" stopOpacity="0.3" />
            </LinearGradient>
        </Defs>
    </Svg>
);
export default SVGComponent;
